import { render, staticRenderFns } from "./DataEditor.vue?vue&type=template&id=f55da9a8&scoped=true"
import script from "./DataEditor.vue?vue&type=script&lang=js"
export * from "./DataEditor.vue?vue&type=script&lang=js"
import style0 from "./DataEditor.vue?vue&type=style&index=0&id=f55da9a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55da9a8",
  null
  
)

export default component.exports